module.exports = __webpack_public_path__ + "assets/img/2_827_big.01cee179.jpg";